import { breakpointsVuetify } from '@vueuse/core'
import { VIcon } from 'vuetify/components/VIcon'
import { defineThemeConfig } from '@core'
import { Skins } from '@core/enums'

// ❗ Logo SVG must be imported with ?raw suffix
import logo from '@images/logo.svg?raw'
import { AppContentLayoutNav, ContentWidth, FooterType, NavbarType } from '@layouts/enums'

export const { themeConfig, layoutConfig } = defineThemeConfig({
  app: {
    title: 'vortex',
    subTitle: 'all knowing, ever powerful.',
    logo: h('div', {
      innerHTML: logo,
      style: 'line-height:0; color: rgb(var(--v-global-theme-primary))',
    }),
    contentWidth: ContentWidth.Boxed,
    contentLayoutNav: AppContentLayoutNav.Vertical,
    overlayNavFromBreakpoint: breakpointsVuetify.md + 16, // 16 for scrollbar. Docs: https://next.vuetifyjs.com/en/features/display-and-platform/
    theme: 'dark',
    skin: Skins.Default,
    iconRenderer: VIcon,
    userPreferences: {
      displayDateFormat: 'd-m-Y',
      displayTimeFormat: 'H:i',
      displayDateTimeFormat: 'd-m-Y H:i',
    },

    i18n: {
      enable: false,
      defaultLocale: 'en',
      langConfig: [
        {
          label: 'English',
          i18nLang: 'en',
          isRTL: false,
        },
        {
          label: 'French',
          i18nLang: 'fr',
          isRTL: false,
        },
        {
          label: 'Arabic',
          i18nLang: 'ar',
          isRTL: true,
        },
      ],
    },
  },
  navbar: {
    type: NavbarType.Sticky,
    navbarBlur: true,
  },
  footer: { type: FooterType.Static },
  verticalNav: {
    isVerticalNavCollapsed: false,
    defaultNavItemIconProps: { icon: 'tabler-circle' },
    isVerticalNavSemiDark: false,
  },
  horizontalNav: {
    type: 'sticky',
    transition: 'slide-y-reverse-transition',
    popoverOffset: 6,
    disabled: true,
  },

  icons: {
    chevronUp: { icon: 'tabler-chevron-up' },
    chevronDown: { icon: 'tabler-chevron-down' },
    chevronRight: { icon: 'tabler-chevron-right', size: 20 },
    chevronLeft: { icon: 'tabler-chevron-left', size: 20 },
    reload: { icon: 'tabler-refresh', size: 20 },
    close: { icon: 'tabler-x' },
    verticalNavPinned: { icon: 'tabler-circle-dot' },
    verticalNavUnPinned: { icon: 'tabler-circle' },
    sectionTitlePlaceholder: { icon: 'tabler-minus' },
    inlineSave: { icon: 'tabler-arrow-big-left-lines' },
    buttonSave: { icon: 'tabler-device-floppy' },
    buttonCreate: { icon: 'tabler-device-floppy' },
    buttonDelete: { icon: 'tabler-trash' },
    dark: { icon: 'tabler-moon-stars' },
    light: { icon: 'tabler-sun-high' },
    search: { icon: 'tabler-search' },
    settings: { icon: 'tabler-settings' },
    peek: { icon: 'tabler-zoom' },
    changeIcon: { icon: 'tabler-asterisk' },

    //info: { icon: 'tabler-question-mark' }
    info: { icon: 'tabler-info-circle' },
  },
})
